import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-black mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-black`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "5 powodów, dla których sklepy detaliczne przechodzą na elektroniczne etykiety cenowe." }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Dynamiczne zmiany cen, rosnące koszty pracy oraz potrzeba optymalizacji procesów sprawiają, że coraz więcej sklepów wdraża elektroniczne etykiety cenowe (ESL). Rozwiązanie, które jeszcze kilka lat temu było stosowane głównie w dużych sieciach, dziś staje się standardem również w mniejszych i średnich sklepach.</p>

            <h2>Oto 5 kluczowych powodów, dla których branża detaliczna masowo decyduje się na tę technologię:</h2>
            <h2>1. Natychmiastowa aktualizacja cen w całym sklepie</h2>
            <p>Ceny w sklepach zmieniają się czasem nawet kilka razy dziennie – szczególnie w kategorii warzyw, owoców, mięsa czy nabiału. Dzięki ESL:
            <ul>
              <li>aktualizacja trwa kilka sekund,</li>
              <li>ceny są zmieniane centralnie,</li>
              <li>ryzyko pomyłek jest praktycznie zerowe.</li>
            </ul>
            Sklep nie musi już angażować pracowników do ręcznego wymieniania etykiet, co przekłada się na oszczędność czasu i redukcję kosztów operacyjnych.</p>
            
            <h2>2. Eliminacja błędów cenowych i reklamacji</h2>
            <p>Papierowe etykiety często powodują niezgodności między ceną na półce a tą w systemie kasowym. ESL rozwiązuje ten problem, bo:
            <ul>
              <li>cena na półce zawsze zgadza się z ceną w systemie,</li>
              <li>klienci nie zgłaszają już reklamacji,</li>
              <li>sklep unika strat wynikających z pomyłek.</li>
            </ul>
            To szczególnie ważne w sklepach o dużej rotacji towarów, gdzie błędy cenowe mogą kosztować tysiące złotych miesięcznie.</p>

            <h2>3. Niższe koszty pracy i większa efektywność</h2>
            <p>W branży detalicznej brakuje pracowników, a rotacja jest wysoka. Elektroniczne etykiety cenowe pozwalają:
            <ul>
              <li>ograniczyć czas poświęcany na zmiany cen o 80–90%,</li>
              <li>oddelegować pracowników do obsługi klienta i sprzedaży,</li>
              <li>automatyzować powtarzalne zadania.</li>
            </ul>
            To jedno z najważniejszych usprawnień w codziennej pracy sklepu.</p>

            <h2>4. Lepsze doświadczenie zakupowe i przejrzystość oferty</h2>
            <p>ESL mają wyraźny, czytelny wyświetlacz, który:
            <ul>
              <li>jest doskonale widoczny z każdej strony,</li>
              <li>prezentuje cenę, promocję, kod kreskowy, pochodzenie produktu, a nawet oceny klientów,</li>
              <li>eliminuje „chaos” związany z papierowymi etykietami.</li>
            </ul>
            Nowoczesny wygląd półek zwiększa profesjonalizm sklepu i wpływa na wyższą konwersję zakupową.</p>

            <h2>5. Możliwość wdrażania dynamicznych promocji i inteligentnych akcji cenowych</h2>
            <p>Dzięki elektronicznym etykietom sklepy mogą:
            <ul>
              <li>prowadzić dynamiczne promocje, np. obniżanie ceny produktów o krótkiej dacie,</li>
              <li>wprowadzać „happy hours” lub rabaty w określonych godzinach,</li>
              <li>automatycznie zarządzać promocjami weekendowymi i sezonowymi.</li>
            </ul>
            Umożliwia to pełne wykorzystanie potencjału sprzedażowego i minimalizację strat.</p>

            <h2>Podsumowanie</h2>
            <p>Elektroniczne etykiety cenowe to inwestycja, która szybko się zwraca. Sklepy decydują się na nie, ponieważ zapewniają:
            <ul>
              <li>pełną automatyzację zmian cen,</li>
              <li>przejrzystość i profesjonalny wygląd półek,</li>
              <li>mniejsze koszty pracy,</li>
              <li>redukcję błędów i reklamacji,</li>
              <li>możliwość prowadzenia inteligentnych akcji promocyjnych.</li>
            </ul>
            ESL to nie tylko „nowoczesny gadżet” – to rozwiązanie, które realnie podnosi konkurencyjność sklepów i wpisuje się w kierunek rozwoju handlu detalicznego.</p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
